export default [
    {
        name: 'base',
        data: {},
        items:
        [
            { name: 'lennaTexture', source: '/assets/lenna.png', type: 'texture' },
        ]
    }
]